module.exports = __webpack_public_path__ + "assets/google-slides-icon.412a5d2c.svg";